__turbopack_context__.v({
  "lig": "Thermometer-module__2kSe0a__lig",
  "root": "Thermometer-module__2kSe0a__root",
});
